module.exports = __webpack_public_path__ + "static/media/6.daad0d83.svg";